import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  userId:null,
  role: null,
  token: null,
  district: null,
  isViewOnly:false,
  // login: () => {},
  // logout: () => {},
});
